import environment from 'apps/fe-donation/libs/environment'
import { GraphQLClient } from 'graphql-request'

export const GIVEEASY_CORRELATION_HEADER = 'x-correlation-id'

export const getGatewayRequestHeaders = (request: Request) => {
  const correlationId = request.headers.get(GIVEEASY_CORRELATION_HEADER) ?? ''
  return {
    [GIVEEASY_CORRELATION_HEADER]: correlationId,
  }
}

export const graphQLClient = new GraphQLClient(`${environment.gatewayEndpoint}/graphql`)

export const OkResponse = () => new Response(JSON.stringify({ ok: true }), { status: 200 })
export const UnauthorizedResponse = () =>
  new Response(JSON.stringify({ ok: false, message: 'Unauthorized' }), { status: 401 })
export const BadRequestResponse = (message: string) =>
  new Response(JSON.stringify({ ok: false, message }), { status: 400 })
